// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.clearIcon = {
    size: 12,
    css: css`
        position: absolute;
        right: 35px;
        top: 42px;
        cursor: pointer;
    `,
};

productSelectorStyles.buttonGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        justify-content: flex-end;
    `,
};

productSelectorStyles.selectButton = {
    css: css`
        margin-top: 21px;
        margin-bottom: 15px;
        height: 36px;
        ${xScreen("lte", "sm")} {
            margin-top: 30px;
            margin-bottom: 0;
            width: 100%;
        }
    `,
};
